<!-- 询价单 -->
<template>
  <div id="xj" class="business-content-main">
    <div class="bread-nav">
      <div>您当前位置：</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客服</el-breadcrumb-item>
        <el-breadcrumb-item>询价管理</el-breadcrumb-item>
        <el-breadcrumb-item>内部询价单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="search-ctn">
      <div class="search-name">询价单号:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchData.ICode"
        placeholder="请输入询价单号"
      ></el-input>
      <div class="search-name">时间:</div>
      <el-date-picker
        :picker-options="startDateOps"
        class="search-item"
        v-model="searchData.InquiryBeginDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="date"
        size="small"
        placeholder="选择日期"
      ></el-date-picker>
      <span class="search-name">至</span>
      <el-date-picker
        :picker-options="endDateOps"
        class="search-item"
        v-model="searchData.InquiryEndDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="date"
        size="small"
        placeholder="选择日期"
      ></el-date-picker>
      <div class="search-name">状态:</div>
      <el-select size="small" class="search-item" v-model="searchData.State" placeholder="请选择">
        <el-option
          v-for="item in orderState"
          :key="item.Tkey"
          :label="item.TValue"
          :value="item.Tkey"
        ></el-option>
      </el-select>
      <!--<div class="search-name">客服组:</div>-->
      <!--<el-select-->
      <!--@change="getServicesByGId"-->
      <!--size="small"-->
      <!--class="search-item"-->
      <!--v-model="searchData.GroupId"-->
      <!--placeholder="请选择">-->
      <!--<el-option-->
      <!--v-for="item in serviceGroup"-->
      <!--:key="item.Id"-->
      <!--:label="item.Name"-->
      <!--:value="item.Id">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--<div class="search-name">客服人员:</div>-->
      <!--<el-select-->
      <!--size="small"-->
      <!--class="search-item"-->
      <!--v-model="searchData.Id"-->
      <!--placeholder="请选择">-->
      <!--<el-option-->
      <!--v-for="item in services"-->
      <!--:key="item.Id"-->
      <!--:label="item.Name"-->
      <!--:value="item.Id">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        class="search-btn"
        @click="handleSearch"
      >查询</el-button>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-refresh"
        class="search-btn"
        @click="resetSearch"
      >重置</el-button>
    </div>
    <div class="table-ctn">
      <el-table
        :header-cell-style="{background:'#F2F6FC'}"
        :data="tableData"
        border=""
        style="width: 100%"
      >
        <el-table-column width="190px" show-overflow-tooltip prop="ICode" label="单号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="UName" label="客户名称"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态">
          <template slot-scope="scope">{{ scope.row.StateName}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="PriceSumSell" label="售价总计"></el-table-column>
        <el-table-column show-overflow-tooltip label="询价时间">
          <template slot-scope="scope">{{ scope.row.CreateTime|formatDate}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="Remark" label="备注"></el-table-column>
        <el-table-column show-overflow-tooltip label="来源">
          <template slot-scope="scope">{{ scope.row.Source|SourceHandle }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showDialog(scope.row)"
              v-if="permission.转为订单&&scope.row.State == 2&&scope.row.Source<2"
            >转为订单</el-button>
            <el-button
              type="text"
              size="small"
              @click="SynchToEntpIB(scope.row.InquiryId)"
              v-if="permission.同步客户询价单&&scope.row.State == 2&&scope.row.Source==2"
            >同步客户询价单</el-button>
            <el-button type="text" size="small" @click="openOrderDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-ctn">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchData.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="searchData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableDataLength"
      ></el-pagination>
    </div>
    <el-dialog
      title="询价单详情"
      :visible.sync="detailDialogVisible"
      width="75%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeOrderDetail()"
    >
      <el-table border="" :fit="true" :data="orderDetail" ref="detailTable">
        <el-table-column width="160px" prop="GoodCode" label="商品编码"></el-table-column>
        <el-table-column prop="GoodName" label="商品名称"></el-table-column>
        <el-table-column prop="GoodName" label="英文名称"></el-table-column>
        <el-table-column prop="BrandName" label="品牌"></el-table-column>
        <el-table-column width="50px" prop="Size" label="尺寸"></el-table-column>
        <el-table-column width="50px" prop="Quality" label="重量"></el-table-column>
        <el-table-column width="50px" prop="Unit" label="单位"></el-table-column>
        <el-table-column width="80px" prop="minPrice" label="起售价"></el-table-column>
        <el-table-column width="100px" prop="SellPrice" label="售价"></el-table-column>
        <el-table-column width="50px" prop="Count" label="数量"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :before-close="closeDialog"
      width="1000px"
      title="转为订单"
      :visible.sync="dialogVisible"
    >
      <transToOrder :InquiryId="InquiryId" @closeDialog="closeDialog" ref="transToOrder"></transToOrder>
    </el-dialog>
  </div>
</template>
<script>
import transToOrder from "@/components/business/inquire/transToOrder.vue";
export default {
  name: "company",
  components: {
    transToOrder
  },
  data() {
    return {
      startDateOps: {
        disabledDate: time => {
          if (this.searchData.InquiryEndDate != "") {
            return time.getTime() > new Date(this.searchData.InquiryEndDate);
          }
        }
      },
      endDateOps: {
        disabledDate: time => {
          if (this.searchData.InquiryBeginDate != "") {
            return time.getTime() < new Date(this.searchData.BeginDate);
          }
        }
      },
      dialogVisible: false,
      detailDialogVisible: false,
      orderDetail: [],
      formLabelWidth: "120px",
      orderState: [
        { Tkey: "0", TValue: "等待报价" },
        { Tkey: "1", TValue: "已报价,未审核" },
        { Tkey: "2", TValue: "已报价，审核通过" },
        { Tkey: "3", TValue: "等待重新报价" },
        { Tkey: "4", TValue: "作废询价单" }
      ],
      serviceGroup: [],
      services: [],
      searchData: {
        ICode: "",
        State: "",
        InquiryBeginDate: "",
        InquiryEndDate: "",
        page: 1, // 当前页数
        limit: 10 // 每页限制条数
      },
      tableData: [],
      tableDataLength: 0,
      // 要转的订单数据
      toOrderOrange: {},
      // 转为订单数据
      toOrderData: {},
      InquiryId: "", // 选中订单的询价id
      permission: {}
    };
  },
  mounted() {
    this.serviceGroup = this.$store.state.ServiceGroup;
    this.getTableData();
    this.$util.getPermission("内部询价单").then(res => {
      this.permission = res;
    });
  },
  filters: {
    StateHandle(value) {
      let result = "";
      switch (value) {
        case 0:
          result = "询问价格";
          break;
        case 1:
          result = "已报价";
          break;
        case 2:
          result = "审核不通过";
          break;
        case 3:
          result = "采购退回";
          break;
        case 4:
          result = "重新询价";
          break;
        case 5:
          result = "重新报价";
          break;
      }
      return result;
    },
    SourceHandle(val) {
      let result = "";
      switch (val) {
        case 0:
          result = "客服";
          break;
        case 1:
          result = "维修订单";
          break;
        case 2:
          result = "客户询价单";
          break;
      }
      return result;
    }
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$refs.transToOrder.clearVal();
      this.dialogVisible = false;
    },
    // 转为订单
    toOrder() {
      this.axios
        .post("/Inquiry/TransferToOrder", this.toOrderData)
        .then(() => {
          this.$message({
            message: "转为订单成功",
            type: "success"
          });
          this.dialogVisible = false;
          this.toOrderData = {
            IBId: "",
            EntpId: "",
            DiscountAmount: "",
            ShipAddr: "",
            ShipTypeName: "",
            OrderAmount: ""
          };
        })
        .catch(error => {
          this.$message.error(error);
        });
    },

    // 优惠金额改变
    DiscountAmountChange() {
      let yh = Number(this.toOrderData.DiscountAmount);
      let oprice = Number(this.toOrderOrange.PriceSumCome);
      if (oprice < yh) {
        this.$message({
          message: "优惠价格不能大于订单总价",
          type: "warning"
        });
        return;
      } else {
        this.toOrderData.OrderAmount = oprice - yh;
      }
    },
    //转为订单弹窗
    showDialog(data) {
      this.InquiryId = data.InquiryId;
      this.axios
        .get("/Inquiry/GetQuotationOrder", {
          params: {
            IBId: this.InquiryId
          }
        })
        .then(response => {
          let _data = response.data.data;
          if (_data[0]) {
            this.dialogVisible = true;
          } else {
            this.$util.warningMsg("该询价单未审核或已转为订单");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //查看详情弹窗
    openOrderDetail(item) {
      this.orderDetail = [];
      this.axios
        .get("/Inquiry/GetQuotationOrder", {
          params: {
            IBId: item.InquiryId
          }
        })
        .then(response => {
          let data = response.data.data[0];
          for (let i = 0; i < data.DetailList.length; i++) {
            data.DetailList[i].minPrice = data.DetailList[i].SellPrice;
          }
          this.orderDetail = data.DetailList;
        })
        .catch(error => {
          console.log(error);
        });
      this.detailDialogVisible = true;
    },
    closeOrderDetail() {
      this.orderDetail = [];
      this.detailDialogVisible = false;
    },
    getTableData() {
      this.axios
        .get("/Inquiry/GetInquiryOrderList", {
          params: this.searchData
        })
        .then(response => {
          this.tableData = response.data.data;
          this.tableDataLength = response.data.count;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //  根据客服组ID获取所有在职客服
    getServicesByGId(gId) {
      this.$util.GetServicesByGId(gId).then(value => {
        this.services = value;
        this.searchData.Id = "";
      });
    },
    //同步到客户询价单
    SynchToEntpIB(bid) {
      this.axios
        .post(
          "/Inquiry/SynchEntpIBGoodsFromErpIB?bid="+bid,
          { },
        )
        .then(() => {
          this.$message({
            message: "同步数据成功",
            type: "success"
          });
        })
        .catch(error => {
          this.$message.error(error.data.errmsg);
        });
    },
    handleSearch() {
      this.searchData.page = 1;
      this.getTableData();
    },
    resetSearch() {
      this.searchData = {
        ICode: "",
        SId: "",
        StartDate: "",
        EndDate: "",
        GroupId: "",
        page: 1, // 当前页数
        limit: 10, // 每页限制条数
        key: "" //关键字查询
      };
    },
    handleSizeChange(val) {
      this.searchData.limit = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.searchData.page = val;
      this.getTableData();
    }
  }
};
</script>
<style lang="less" scoped>
</style>
